<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="dialogForm"
          @submit.native.prevent
        >
          <el-form-item label="卡牌名称">
            <el-input
              v-model="dialogForm.name"
              placeholder="请输入卡牌名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="系列">
            <el-select v-model="dialogForm.series_id" clearable placeholder="请选择卡牌系列">
              <el-option
                v-for="item in seriesList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="等级" prop="org_id">
            <el-select v-model="dialogForm.org_id" placeholder="请选择卡牌等级">
              <el-option
                v-for="item in businessList"
                :key="item.org_id"
                :label="item.name"
                :value="item.org_id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="状态" prop="org_id">
            <el-select v-model="dialogForm.status" clearable placeholder="请选择卡牌等级">
              <el-option
                v-for="item in businessList"
                :key="item.state"
                :label="item.label"
                :value="item.state"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              size="medium"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        row-key="transaction_id"
        border
        stripe
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="卡牌名称"
          prop="name"
          height="500"
        />
        <el-table-column
          align="center"
          label="正面反面点亮图"
          width="260"
        >
          <template #default="{ row }">
            <!-- <img :src="row.front_up" style="width: 100px; height: 100px;" alt="" /> -->
            <el-image 
              style="width: 100px; height: 100px"
              :src="row.front_up"
              v-if="row.front_up"
              :preview-src-list="[row.front_up]">
            </el-image>
            <!-- <img :src="row.front_down" style="width: 100px; height: 100px; margin-left: 20px;" alt="" /> -->
             <el-image 
              style="width: 100px; height: 100px; margin-left: 20px;"
              :src="row.front_down" 
              v-if="row.front_down"
              :preview-src-list="[row.front_down]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="等级"
          prop="level"
          height="500"
        />
        <el-table-column
          align="center"
          label="状态"
          prop="psp_order_id"
          height="500"
        >
          <template #default="{ row }">
            <span>{{ row.status == 1 ? '上架' : '下架' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="系列"
          prop="series_name"
          height="500"
        />
        <el-table-column
          align="center"
          label="创建日期"
          height="500"
        >
          <template #default="{ row }">
            <span>{{ transTime(row.insert_time) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getCardList, getSeriesList } from "@/api/radio"
import { transTime } from '@/utils/transTime'
import { Message } from "element-ui";

export default {
  data() {
    return {
      transTime,
      dialogForm: {
        series_id: null,
        name: "",
        level: '',
        status: null,
      }, // 模态框展示的数据
      queryForm: {
        page: 1,
        pageSize: 10,
      },
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0,
      tableData: [],
      seriesList: [],
      businessList: [
        {
          state: '1',
          label: '上架'
        },
        {
          state: '0',
          label: "下架",
        }
      ]
    };
  },
  created() {
    this.getSeries()
    this.fetchData()
  },
  mounted() {},

  methods: {
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    async fetchData() {
      // 这里发请求
      let params = {
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
        level: this.dialogForm.level,
        name: this.dialogForm.name,
        series_id: this.dialogForm.series_id ? this.dialogForm.series_id : -1,
        status: this.dialogForm.status ? this.dialogForm.status : -1
      }
      await getCardList(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async getSeries(){
      // 这里发请求
      let params = {
        name: '',
        page: 1,
        pageSize: 10000000000,
      };
      await getSeriesList(params)
        .then((res) => {
          if (res && res.code) {
            this.seriesList = res.data.data_list
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleQuery(){
      this.queryForm.page = 1
      this.fetchData()
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
